import React from 'react';
import { FieldSet } from '../../components/Form';
import ReorderableList from '../../components/ReorderableList';
import type { DocumentType } from '../../graphql/generated/gql';
import { gql } from '../../graphql/generated/gql';
import type { SeriesAddPost_PostFragment } from '../../graphql/generated/graphql';
import SeriesRow from '../SeriesRow';
import SeriesAddPost from './SeriesAddPost';
import * as styles from './SeriesPostManager.module.scss';

const POSTS_FRAGMENT = gql(`
  fragment SeriesPostManager_posts on Post {
    id
    ...SeriesAddPost_post
    ...SeriesRow_post
  }
`);

interface SeriesPostManagerProps {
  seriesId?: string;
  requiredPostId?: string;
  onChange(items: SeriesAddPost_PostFragment[]): void;
  posts: DocumentType<typeof POSTS_FRAGMENT>[];
}

const SeriesPostManager = ({
  posts,
  requiredPostId,
  seriesId,
  onChange,
}: SeriesPostManagerProps) => (
  <FieldSet legend="Order">
    <ReorderableList
      items={posts}
      renderItem={(post, index) => (
        <SeriesRow post={post} index={index} noLink noPadding />
      )}
      isRemovable={(post) => posts.length > 1 && post.id !== requiredPostId}
      onChange={onChange}
    />
    <div className={styles.addContainer}>
      <SeriesAddPost
        posts={posts}
        seriesId={seriesId}
        onAdd={(item) => onChange([...posts, item])}
      />
    </div>
  </FieldSet>
);

export default SeriesPostManager;
